import React from 'react';

const About = () => {
  return (
    <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-5 align-items-center">
          <div className="col-lg-6 wow fadeIn" data-wow-delay="0.1s">
            <div className="about-img position-relative overflow-hidden p-5 pe-0">
              <img className="img-fluid w-100" src="/img/about.png" alt="About" style={{maxHeight: '700px', objectFit: 'cover'}} />
            </div>
          </div>
          <div className="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
            <h1 className="display-5 mb-4">Best Quality Fresh Natural Ingredients, Crafted For Your Wellness</h1>
            <p className="mb-4">At Organique Juice Bar, we begin with carefully selected natural ingredients, chosen for peak freshness, flavor, and nutritional value. Every bite and sip is crafted with real ingredients—never artificial additives—so your body receives exactly what it needs.</p>
            <p className="mb-4">Our philosophy is simple: clean recipes, balanced nutrition, and refined taste you can feel confident enjoying every day.</p>
            <p><i className="fa fa-check text-brand me-3"></i>Fresh, high-quality ingredients selected daily</p>
            <p><i className="fa fa-check text-brand me-3"></i>No artificial colors, flavors, or preservatives</p>
            <p><i className="fa fa-check text-brand me-3"></i>Thoughtfully balanced for energy, digestion, and immunity</p>
            {/*<a className="btn btn-primary rounded-pill py-3 px-5 mt-3" href="#about">Read More</a>*/}
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;